<template>
  <a
    class="font-mono text-sm"
    style="
      border: 2px solid black;
      border-radius: 5px;
      display: flex;
      flex-direction: column;

      overflow: hidden;
      text-decoration: none;
      max-width: 140px;
    "
    href="https://api.backlog.rip/auth/steam">
    <div
      style="
        color: rgb(228, 228, 231);
        background-color: black;
        text-transform: uppercase;
        width: 100%;
        text-align: center;
        padding: 5px;
        letter-spacing: 1px;
        font-weight: 500;
        font-size: 0.75rem;
      ">
      Sign in with
    </div>
    <div style="background-color: rgb(196 196 209); width: 100%; text-align: center; padding: 5px">
      <b-logo name="steam-full" class="me-2" size="18" />
    </div>
  </a>
</template>

<script></script>
